import { Injectable } from '@angular/core';

import { HttpService } from '../../../tms-shared';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderStatusReferenceService extends BaseReferenceService {
  constructor(protected httpService: HttpService) {
    super('PurchaseOrderStatusReference', httpService);
  }
}
